<template>
  <!-- NO ITEMPROP -->
  <div class="card-content card-content-new">
    <!-- Review Head Section Desktop view Begin -->
    <div class="media-content inner-review-card card-head reviewer-info">
      <figure class="media-left">
        <!-- Author Avatar -->
        <a :href="`/profile/${review.author_id}`">
          <avatar
            :username="review.author"
          >
          </avatar>
        </a>
      </figure>
      <rating
        class="card-rating is-desktop is-hidden-mobile is-hidden-tablet-only"
        :stars="review.review_rating"
        :review-card="compress"
      >
      </rating>
      <rating
        class="card-rating is-mobile is-hidden-desktop is-12"
        :stars="review.review_rating"
        :review-card="compress"
      >
      </rating>
      <a class="review-author" :href="`/profile/${review.author_id}`">{{review.author}}</a>
    </div>
    <!-- Review Head Section Desktop view End -->
    <div class="author author-new">
        <span class="is-pulled-right review-date">
          {{ review.created_at | formattedDateAndTime }}
        </span>
    </div>
    <!-- Review Description Begin -->
    <div class="media-content media-content-new-content media-content-new-content-new">
      <div class="rev-title review-title-new">
        <strong>
          <a
            :href="`/${review.business_slug}/reviews/${review.permalink}`"
            v-html="review.review_title"
          >
          </a>
        </strong>
      </div>
      <div class="blurb">
        <p :class="[{'ellipses': isLongReviewDescription}]">
          <a
            :href="`/${review.business_slug}/reviews/${review.permalink}`"
            v-html="review.review_content">
          </a>
        </p>
      </div>
    </div>
    <!-- Review Description End -->
    <hr>
  </div>
</template>
<script>
  import moment from 'moment'
  import Avatar from 'vue-avatar'
  import Rating from '@/components/Rating'

  export default {
    name: 'BizListFbReviewCard',
    components: {
      Avatar,
      Rating
    },
    props: {
      authorAvatarColor: {
        type: String,
        default: ''
      },
      review: {
        type: Object
      }
    },
    data() {
      return {
        compress: true
      }
    },
    computed: {
      /**
       * Check if review description has any specific length
       * @return {boolean}
       **/
      isLongReviewDescription() {
        return this.review.review_content.length > 50
      }
    },
    filters: {
      /**
       * Customising the date in format as (12 Sep 2015 at 18:09 pm)
       * @return {string}
       **/
      formattedDateAndTime(reviewDate) {
        return moment(reviewDate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY [at] HH:mma')
      },
    }
  }
</script>
<style scoped>
  .card {
    border: 1px solid #C9C9C9;
    box-shadow: none;
  }

  .card.bottom-margin {
    margin-bottom: 2rem;
  }

  a, a:hover, a:visited {
    text-decoration: none;
    color: #58595B;
  }

  .media-content {
    width: 100%;
  }

  .media-content.inner-review-card {
    width: 100%
  }

  .media-content > h1 {
    font-size: 1.0rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .media-content > h2 {
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    margin-right: 2rem;
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .media-content > .is-detail-card {
    font-size: 1rem;
    font-weight: bold;
    width: 90%;
  }

  .media-content > .blurb {
    font-size: 0.9rem;
    overflow: hidden;
    position: relative;
    /* use this value to count block height */
    line-height: 1.4rem;
    /* max-height = line-height (1.2) * lines max number (3) */
    max-height: 4.2rem;
    /* fix problem when last visible word doesn't adjoin right side  */
    text-align: left;
    word-break: break-word;
    margin-top: 1%;
  }

  .media-content > .full-content {
    font-size: 0.9rem;
    line-height: 1.4rem;
    text-align: left;
    margin-right: 2rem;
    padding-right: 1rem;
    margin-top: 1.5rem;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .ellipses:before {
    content: '...';
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .media-content > .blurb:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1em;
    height: 1em;
    margin-top: 0.2em;
    background: #ffffff;
  }

  .author {
    color: #8A8C91;
    font-size: 0.8rem;
    margin-top: 1.2rem;
  }

  .author a, .author a:hover, .author a:visited {
    text-decoration: none;
    color: #8A8C91;
  }

  .media-right > p {
    font-size: 1.4rem;
    margin-left: 1.4rem;
  }

  .media-left > a > .image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .p-t-8 {
    padding-top: 8px;
  }

  .nps-rating a {
    border: 1px solid grey;
    border-radius: 0;
    padding: 1.3rem 2rem;
    font-size: 0.85rem;
  }

  /*Review Card CSS Begin*/
  .card-head {
    display: flex;
    align-items: center;
  }

  .card-rating {
    display: inline-block;
  }

  .card-content > hr {
    background-color: #dbdbdb;
    border: none;
    height: 1.0px;
  }

  .reviewer-info p {
    color: #8A8C91;
    font-size: .9em;
    font-weight: 500;
  }

  /*Review Card CSS End*/
  @media screen and (min-width: 768px) {
    .m-l-54 {
      margin-left: 54px;
    }
  }

  @media screen and (max-width: 767px) {
    .media-content.inner-review-card {
      overflow: hidden;
    }

    .media-content > .blurb, .media-content > .full-content {
      margin-right: 1rem;
    }

    .card {
      border: none;
      border-top: 1px solid #C9C9C9;
    }

    .card.bottom-margin {
      margin-bottom: 0;
      border: none;
      border-bottom: 1px solid #C9C9C9;
    }

    .card.bottom-margin ~ .card {
      margin-bottom: 0;
      border: none;
      border-bottom: 1px solid #C9C9C9;
      margin-top: 0;
    }

    .is-review-details .card {
      margin-bottom: 0;
      margin-top: 0;
    }

    .is-review-details .card .media-left {
      display: none;
    }

    .card.bottom-margin ~ .card .media-left {
      display: none;
    }

    .card.bottom-margin .media-content {
      overflow: unset;
    }

    .card.bottom-margin .media-content, .card.bottom-margin .media-content > .is-detail-card, .card.bottom-margin .media-content > h1, .card.bottom-margin .media-content > h2 {
      width: 100%;
    }

    .card.bottom-margin .media-content > .full-content {
      margin-right: 0;
      padding-right: 0;
    }

    .nps-rating {
      position: relative;
      right: 0;
      top: 0;
      margin-top: 10%;
    }

    .nps-rating a {
      display: block;
      text-align: center;
      display: flex;
    }

    .rev-title strong a {
      overflow-wrap: break-word;
      word-wrap: break-word;
      -ms-word-break: break-all;
      word-break: break-all;
      word-break: break-word;
      -ms-hyphens: auto;
      -moz-hyphens: auto;
      -webkit-hyphens: auto;
      hyphens: auto;
    }
  }

  .rev-title {
    margin-top: 1%;
  }

  .rev-title strong a {
    word-wrap: break-word;
  }

  .card-content-new {
    padding: 0px 0px !important;
    position: relative !important;
  }

  .media-content-new-content {
    padding-left: 68px !important;
  }

  .author-new {
    margin-top: 0px !important;
  }

  .media_content_new_content_new {
    margin-top: 0px !important;
  }

  .review-title-new {
    margin-top: 10px !important;
    font-size: 14px !important;
  }

  .review-title-heading {
    margin-top: 10px !important;
  }

  .review-author {
    width: 100%;
    position: absolute;
    top: 40px;
    font-size: 12px;
    left: 70px;
    color:#8A8C91;
  }
  .review-date {
    color: #58595B;
    font-size: 12px;
    opacity: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/components/BizListFbReviewCard.vue